import { NarrativeState, Node } from '../types/narrative';

export const countWords = (text: string): number => {
  return text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;
};

export const checkNodeWordLimits = (node: Node, wordLimit: number = 100): boolean => {
  // Check main text
  if (node.text && countWords(node.text) > wordLimit) {
    return false;
  }

  // Check world-specific text for conditional nodes
  if (node.textMainGoodWorld && countWords(node.textMainGoodWorld) > wordLimit) {
    return false;
  }
  if (node.textMainBadWorld && countWords(node.textMainBadWorld) > wordLimit) {
    return false;
  }

  return true;
};

export const getCurrentNodeWordCount = (narrativeState: NarrativeState): number => {
  const currentNode = narrativeState.nodes[narrativeState.currentNodeId];
  if (!currentNode) return 0;

  // Get the main text based on node type
  if (currentNode.type === 'Conditional') {
    // For conditional nodes, check both world paths
    const goodWorldCount = currentNode.textMainGoodWorld
      ? countWords(currentNode.textMainGoodWorld)
      : 0;
    const badWorldCount = currentNode.textMainBadWorld
      ? countWords(currentNode.textMainBadWorld)
      : 0;
    return Math.max(goodWorldCount, badWorldCount);
  }

  return currentNode.text ? countWords(currentNode.text) : 0;
};

export const canNavigateFromCurrentNode = (
  narrativeState: NarrativeState,
  wordLimit: number = 100
): boolean => {
  const currentNode = narrativeState.nodes[narrativeState.currentNodeId];
  if (!currentNode) return true;

  return checkNodeWordLimits(currentNode, wordLimit);
};
